<template>
  <section class="section-padding">
    <div class="container">
      <div class="columns is-multiline box">
        <div class="column is-12"><h1 class="title">Prospectos a socios</h1></div>
        <div class="column is-12"><List /></div>
      </div>
    </div>
  </section>
</template>
<script>
import List from '../components/list.vue';
export default { components: { List } };
</script>
